import React from 'react';

const IconNode = ({ ...styles }) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 443 271" {...styles}>
    <path
      className="st0"
      d="M219 270.9c-1.5 0-2.9-.4-4.2-1.1l-13.3-7.9c-2-1.1-1-1.5-.4-1.7 2.7-.9 3.2-1.1 6-2.7.3-.2.7-.1 1 .1l10.2 6.1c.4.2.9.2 1.2 0l39.9-23.1c.4-.2.6-.6.6-1.1v-46.1c0-.5-.2-.9-.6-1.1l-39.9-23c-.4-.2-.9-.2-1.2 0l-39.9 23c-.4.2-.6.7-.6 1.1v46.1c0 .4.2.9.6 1.1l10.9 6.3c5.9 3 9.6-.5 9.6-4v-45.5c0-.6.5-1.2 1.2-1.2h5.1c.6 0 1.2.5 1.2 1.2v45.5c0 7.9-4.3 12.5-11.8 12.5-2.3 0-4.1 0-9.2-2.5l-10.5-6a8.44 8.44 0 01-4.2-7.3v-46.1c0-3 1.6-5.8 4.2-7.3l39.9-23.1c2.5-1.4 5.9-1.4 8.4 0l39.9 23.1c2.6 1.5 4.2 4.3 4.2 7.3v46.1c0 3-1.6 5.8-4.2 7.3L223.2 270c-1.3.6-2.8.9-4.2.9z"
    />
    <path
      className="st0"
      d="M231.3 239.2c-17.5 0-21.1-8-21.1-14.8 0-.6.5-1.2 1.2-1.2h5.2c.6 0 1.1.4 1.1 1 .8 5.3 3.1 7.9 13.7 7.9 8.4 0 12-1.9 12-6.4 0-2.6-1-4.5-14.1-5.8-10.9-1.1-17.7-3.5-17.7-12.2 0-8.1 6.8-12.9 18.2-12.9 12.8 0 19.1 4.4 19.9 14 0 .3-.1.6-.3.9-.2.2-.5.4-.8.4h-5.2c-.5 0-1-.4-1.1-.9-1.2-5.5-4.3-7.3-12.5-7.3-9.2 0-10.3 3.2-10.3 5.6 0 2.9 1.3 3.8 13.7 5.4 12.3 1.6 18.1 3.9 18.1 12.5-.1 8.8-7.3 13.8-20 13.8zM288.9 190.8c0 4.2-3.5 7.7-7.7 7.7s-7.7-3.4-7.7-7.7c0-4.4 3.6-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7zm-14.2 0c0 3.6 2.9 6.5 6.4 6.5 3.6 0 6.5-3 6.5-6.5 0-3.6-2.9-6.4-6.5-6.4-3.4 0-6.4 2.8-6.4 6.4zm3.6-4.3h3c1 0 3 0 3 2.3 0 1.6-1 1.9-1.6 2.1 1.2.1 1.3.9 1.4 2 .1.7.2 1.9.4 2.3h-1.8c0-.4-.3-2.6-.3-2.7-.1-.5-.3-.7-.9-.7H280v3.5h-1.7v-8.8zm1.6 3.8h1.3c1.1 0 1.3-.8 1.3-1.2 0-1.2-.8-1.2-1.3-1.2h-1.4v2.4z"
    />
    <path
      className="st1"
      d="M95.2 90.6c0-1.8-1-3.5-2.6-4.4L50.3 61.7c-.7-.4-1.5-.6-2.3-.7h-.4c-.8 0-1.6.3-2.3.7L2.9 86.1C1.3 87 .3 88.7.3 90.5l.1 65.6c0 .9.5 1.8 1.3 2.2.8.5 1.8.5 2.5 0L29.4 144c1.6-.9 2.6-2.6 2.6-4.4v-30.7c0-1.8 1-3.5 2.6-4.4l10.7-6.2c.8-.5 1.7-.7 2.6-.7.9 0 1.8.2 2.5.7l10.7 6.2c1.6.9 2.6 2.6 2.6 4.4v30.7c0 1.8 1 3.5 2.6 4.4l25.2 14.4c.8.5 1.8.5 2.6 0 .8-.4 1.3-1.3 1.3-2.2l-.2-65.6zM299 .3c-.8-.4-1.8-.4-2.5 0-.8.5-1.3 1.3-1.3 2.2v65c0 .6-.3 1.2-.9 1.6-.6.3-1.2.3-1.8 0L281.9 63c-1.6-.9-3.5-.9-5.1 0l-42.4 24.5c-1.6.9-2.6 2.6-2.6 4.4v48.9c0 1.8 1 3.5 2.6 4.4l42.4 24.5c1.6.9 3.5.9 5.1 0l42.4-24.5c1.6-.9 2.6-2.6 2.6-4.4V18.9c0-1.9-1-3.6-2.6-4.5L299 .3zm-3.9 124.4c0 .5-.2.9-.6 1.1l-14.5 8.4c-.4.2-.9.2-1.3 0l-14.5-8.4c-.4-.2-.6-.7-.6-1.1v-16.8c0-.5.2-.9.6-1.1l14.5-8.4c.4-.2.9-.2 1.3 0l14.5 8.4c.4.2.6.7.6 1.1v16.8zM440.1 107.5c1.6-.9 2.5-2.6 2.5-4.4V91.2c0-1.8-1-3.5-2.5-4.4L398 62.4c-1.6-.9-3.5-.9-5.1 0l-42.4 24.5c-1.6.9-2.6 2.6-2.6 4.4v48.9c0 1.8 1 3.5 2.6 4.4l42.1 24c1.6.9 3.5.9 5 0l25.5-14.2c.8-.4 1.3-1.3 1.3-2.2 0-.9-.5-1.8-1.3-2.2l-42.6-24.5c-.8-.5-1.3-1.3-1.3-2.2V108c0-.9.5-1.8 1.3-2.2l13.3-7.6c.8-.5 1.8-.5 2.6 0l13.3 7.6c.8.5 1.3 1.3 1.3 2.2v12c0 .9.5 1.8 1.3 2.2.8.5 1.8.5 2.6 0l25.2-14.7z"
    />
    <path
      d="M394.8 105.2c.3-.2.7-.2 1 0l8.1 4.7c.3.2.5.5.5.9v9.4c0 .4-.2.7-.5.9l-8.1 4.7c-.3.2-.7.2-1 0l-8.1-4.7c-.3-.2-.5-.5-.5-.9v-9.4c0-.4.2-.7.5-.9l8.1-4.7z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#679e63"
    />
    <g>
      <defs>
        <path
          id="XMLID_143_"
          d="M166.1 62.6c-1.6-.9-3.5-.9-5.1 0l-42.1 24.3c-1.6.9-2.5 2.6-2.5 4.4V140c0 1.8 1 3.5 2.5 4.4l42.1 24.3c1.6.9 3.5.9 5.1 0l42.1-24.3c1.6-.9 2.5-2.6 2.5-4.4V91.3c0-1.8-1-3.5-2.5-4.4l-42.1-24.3z"
        />
      </defs>
      <linearGradient id="XMLID_2_" gradientUnits="userSpaceOnUse" x1="180.702" y1="80.715" x2="142.637" y2="158.367">
        <stop offset="0" stopColor="#3f873f" />
        <stop offset=".33" stopColor="#3f8b3d" />
        <stop offset=".637" stopColor="#3e9638" />
        <stop offset=".934" stopColor="#3da92e" />
        <stop offset="1" stopColor="#3dae2b" />
      </linearGradient>
      <use overflow="visible" fillRule="evenodd" clipRule="evenodd" fill="url(#XMLID_2_)" />
      <clipPath id="XMLID_3_">
        <use overflow="visible" />
      </clipPath>
      <g className="st3">
        <path
          className="st4"
          d="M160.9 62.6l-42.2 24.3c-1.6.9-2.7 2.6-2.7 4.4V140c0 1.2.5 2.3 1.3 3.2L164.7 62c-1.2-.2-2.6-.1-3.8.6zM165 169.2c.4-.1.8-.3 1.2-.5l42.2-24.3c1.6-.9 2.6-2.6 2.6-4.4V91.3c0-1.3-.6-2.6-1.5-3.5L165 169.2z"
        />
        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="157.158" y1="121.353" x2="263.965" y2="42.438">
          <stop offset=".138" stopColor="#3f873f" />
          <stop offset=".402" stopColor="#52a044" />
          <stop offset=".713" stopColor="#64b749" />
          <stop offset=".908" stopColor="#6abf4b" />
        </linearGradient>
        <path
          d="M208.3 86.9L166 62.6c-.4-.2-.9-.4-1.3-.5l-47.4 81.2c.4.5.9.9 1.4 1.2l42.3 24.3c1.2.7 2.6.9 3.9.5l44.5-81.4c-.3-.4-.7-.7-1.1-1z"
          fill="url(#SVGID_1_)"
        />
      </g>
      <g className="st3">
        <path
          className="st4"
          d="M211 140V91.3c0-1.8-1.1-3.5-2.7-4.4L166 62.6c-.5-.3-1-.5-1.6-.6l46.3 79.1c.2-.3.3-.7.3-1.1zM118.7 86.9c-1.6.9-2.7 2.6-2.7 4.4V140c0 1.8 1.2 3.5 2.7 4.4l42.3 24.3c1 .6 2.1.8 3.3.6L119 86.8l-.3.1z"
        />
        <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="114.862" y1="53.834" x2="212.279" y2="53.834">
          <stop offset=".092" stopColor="#6abf4b" />
          <stop offset=".287" stopColor="#64b749" />
          <stop offset=".598" stopColor="#52a044" />
          <stop offset=".862" stopColor="#3f873f" />
        </linearGradient>
        <path fill="url(#SVGID_2_)" d="M159.6 53.7l-.6.3h.8z" />
        <linearGradient
          id="SVGID_3_"
          gradientUnits="userSpaceOnUse"
          x1="114.862"
          y1="115.651"
          x2="212.279"
          y2="115.651"
        >
          <stop offset=".092" stopColor="#6abf4b" />
          <stop offset=".287" stopColor="#64b749" />
          <stop offset=".598" stopColor="#52a044" />
          <stop offset=".862" stopColor="#3f873f" />
        </linearGradient>
        <path
          d="M208.4 144.4c1.2-.7 2.1-1.9 2.5-3.2L164.5 62c-1.2-.2-2.5-.1-3.6.6l-42 24.2 45.3 82.6c.6-.1 1.3-.3 1.9-.6l42.3-24.4z"
          fill="url(#SVGID_3_)"
        />
        <linearGradient
          id="SVGID_4_"
          gradientUnits="userSpaceOnUse"
          x1="114.862"
          y1="143.462"
          x2="212.279"
          y2="143.462"
        >
          <stop offset=".092" stopColor="#6abf4b" />
          <stop offset=".287" stopColor="#64b749" />
          <stop offset=".598" stopColor="#52a044" />
          <stop offset=".862" stopColor="#3f873f" />
        </linearGradient>
        <path fill="url(#SVGID_4_)" d="M212.3 143.6l-.3-.5v.7z" />
        <linearGradient
          id="SVGID_5_"
          gradientUnits="userSpaceOnUse"
          x1="114.862"
          y1="156.032"
          x2="212.279"
          y2="156.032"
        >
          <stop offset=".092" stopColor="#6abf4b" />
          <stop offset=".287" stopColor="#64b749" />
          <stop offset=".598" stopColor="#52a044" />
          <stop offset=".862" stopColor="#3f873f" />
        </linearGradient>
        <path
          d="M208.4 144.4l-42.2 24.3c-.6.3-1.2.5-1.9.6l.8 1.5 46.8-27.1v-.6l-1.2-2c-.2 1.4-1.1 2.6-2.3 3.3z"
          fill="url(#SVGID_5_)"
        />
        <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="226.472" y1="78.412" x2="166.391" y2="200.977">
          <stop offset="0" stopColor="#3f873f" />
          <stop offset=".33" stopColor="#3f8b3d" />
          <stop offset=".637" stopColor="#3e9638" />
          <stop offset=".934" stopColor="#3da92e" />
          <stop offset="1" stopColor="#3dae2b" />
        </linearGradient>
        <path
          d="M208.4 144.4l-42.2 24.3c-.6.3-1.2.5-1.9.6l.8 1.5 46.8-27.1v-.6l-1.2-2c-.2 1.4-1.1 2.6-2.3 3.3z"
          fill="url(#SVGID_6_)"
        />
      </g>
    </g>
  </svg>
);

export default IconNode;
